import { create } from 'zustand';

// headphones — the pair you put on at a Jahva House table (2026-10-31).
//
// Khari: "let's make the spoken word tracks available on a playlist at each
// table. Place a pair of headphones on the table (not blocking the coffee). If
// the user selects them, they see a list of recordings that play just for them.
// The music stops when the headphones are taken off."
//
//   on   { zone, table } while you wear a table's pair, else null
//
// Yours alone: nothing is sent anywhere, and nobody else hears it or sees them
// gone from the table. The 3D pair (TableHeadphones) puts them on and takes them
// off when you walk away from the table; the player (HeadphonesDock) plays
// what you pick and stops the moment they come off; while they are on, the
// room is held quiet under them (the station, a reading upstairs: VenueStage).

export const useHeadphones = create(() => ({ on: null }));

export function putOnHeadphones({ zone, table }) {
  if (!zone || !table) return;
  useHeadphones.setState({ on: { zone, table, at: Date.now() } });
}

export function takeOffHeadphones() {
  if (useHeadphones.getState().on) useHeadphones.setState({ on: null });
}

/** Wearing a pair right now (read by the room's own sound to duck under them). */
export const wearingHeadphones = () => !!useHeadphones.getState().on;
